__webpack_require__.p = "https://wastehero-crm-portal-h1981m2o4-wastehero.vercel.app/";